import { Api } from '@core/api';
import { useError } from '@components/hooks/useError';
import { injectTSDI } from '@core/tsdi';
import { Button } from '@components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from '@components/ui/dialog';
import React from 'react';
import { CommunityLocationDto } from '@api/ChallengeClient';

interface Props {
    location: CommunityLocationDto | null;
    communityId: number;
    onClose: () => void;
    onSuccess: () => void;
}

export const DeleteLocationDialog: React.FC<Props> = ({
    location,
    communityId,
    onClose,
    onSuccess
}) => {
    const { challengeClient } = injectTSDI(Api);
    const showError = useError();
    const [busy, setBusy] = React.useState(false);

    const confirm = async () => {
        if (!location) {
            return;
        }
        setBusy(true);
        try {
            await challengeClient.support.communityLocationSupportControllerDelete(
                communityId,
                location.id
            );
            onSuccess();
        } catch (e) {
            showError(e);
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog
            open={Boolean(location)}
            onOpenChange={(next) => !next && onClose()}
        >
            <DialogContent className="sm:max-w-sm">
                <DialogHeader>
                    <DialogTitle>Delete location</DialogTitle>
                    <DialogDescription>
                        Delete &ldquo;{location?.name}&rdquo;? This cannot be
                        undone.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button variant="ghost" onClick={onClose} disabled={busy}>
                        Cancel
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={confirm}
                        loading={busy}
                    >
                        Delete
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
